import React from "react";
import { Trans } from "react-i18next";

const WingmanAdminUploadWarning = () => {
  return (
    <p className="text-danger font-bold mb-4">
      <Trans>
        Beware you are about to upload documents to Wingman.
        Please review before pushing the import/upload button.
      </Trans>
      <br></br>
      <Trans>
        Some files can take a while to process.
      </Trans>
    </p>
  );
};

export default WingmanAdminUploadWarning;